import React from 'react';
import './components.sass'

const Footer = () => {
    return (
        <footer>

        </footer>
    );
};

export default Footer;